// extracted by mini-css-extract-plugin
export default {"listHeadline":"ARmYm","listHeadline__listWrapper":"kspdD","listHeadline__list":"ggivG","listHeadline__listWrapper___scroll":"ZYTfg","listHeadline__item":"U11_g"};